// Re-engage copy and session landing. Build flag defaults off.
// /api/check_access and /api/app-context send reengage_enabled, and that
// server value overrides the build.

const TRUTHY = new Set(["1", "true", "yes", "on"]);

let runtimeValue = null;

export function parseReengageFlag(value) {
  if (value === true) return true;
  return TRUTHY.has(String(value ?? "").trim().toLowerCase());
}

// CRA inlines REACT_APP_* only when this member access stays a static literal.
export function readBuildTimeReengage() {
  return parseReengageFlag(process.env.REACT_APP_DOPLE_REENGAGE);
}

export function reengageEnabled() {
  if (runtimeValue === null) return readBuildTimeReengage();
  return runtimeValue;
}

// A payload that includes the server key replaces the build. A payload that
// omits the key leaves the current value alone.
export function applyRuntimeReengage(payload) {
  if (!payload || typeof payload !== "object") return reengageEnabled();
  if (Object.prototype.hasOwnProperty.call(payload, "reengage_enabled")) {
    runtimeValue = parseReengageFlag(payload.reengage_enabled);
  } else if (Object.prototype.hasOwnProperty.call(payload, "reengage")) {
    runtimeValue = parseReengageFlag(payload.reengage);
  }
  return reengageEnabled();
}

export function resetReengageForTests() {
  runtimeValue = null;
}
